import * as amplitudeAB from "@amplitude/analytics-browser";

import config from 'config';

export const amplitude = {
  init: () => {
    amplitudeAB.init(config.amplitudeApiKey, {
      autocapture:true,
      serverZone: 'EU'
    });
  },
  setUserId: (userId?: string) => {
    if (userId) {
      amplitudeAB.setUserId(userId);
    }
  },
  track: (
    eventInput: string | amplitudeAB.Types.BaseEvent,
    eventProperties?: Record<string, any> | undefined,
    eventOptions?: amplitudeAB.Types.EventOptions | undefined
  ) => {
    amplitudeAB.track(eventInput, eventProperties, eventOptions);
  }
};
